export const countryOptions: {
	value: string;
	label: string;
}[] = [
	{ value: "ch", label: "Schweiz" },
	{ value: "de", label: "Deutschland" },
	{ value: "at", label: "Österreich" },
	{ value: "li", label: "Liechtenstein" },
	{ value: "fr", label: "Frankreich" },
	{ value: "it", label: "Italien" },
	{ value: "us", label: "Vereinigte Staaten" },
	{ value: "gb", label: "Vereinigtes Königreich" },
	{ value: "af", label: "Afghanistan" },
	{ value: "eg", label: "Ägypten" },
	{ value: "al", label: "Albanien" },
	{ value: "dz", label: "Algerien" },
	{ value: "ad", label: "Andorra" },
	{ value: "ao", label: "Angola" },
	{ value: "ag", label: "Antigua und Barbuda" },
	{ value: "gq", label: "Äquatorialguinea" },
	{ value: "ar", label: "Argentinien" },
	{ value: "am", label: "Armenien" },
	{ value: "az", label: "Aserbaidschan" },
	{ value: "et", label: "Äthiopien" },
	{ value: "au", label: "Australien" },
	{ value: "bs", label: "Bahamas" },
	{ value: "bh", label: "Bahrain" },
	{ value: "bd", label: "Bangladesch" },
	{ value: "bb", label: "Barbados" },
	{ value: "by", label: "Belarus" },
	{ value: "be", label: "Belgien" },
	{ value: "bz", label: "Belize" },
	{ value: "bj", label: "Benin" },
	{ value: "bt", label: "Bhutan" },
	{ value: "bo", label: "Bolivien" },
	{ value: "ba", label: "Bosnien und Herzegowina" },
	{ value: "bw", label: "Botsuana" },
	{ value: "br", label: "Brasilien" },
	{ value: "bn", label: "Brunei" },
	{ value: "bg", label: "Bulgarien" },
	{ value: "bf", label: "Burkina Faso" },
	{ value: "bi", label: "Burundi" },
	{ value: "cl", label: "Chile" },
	{ value: "cn", label: "China" },
	{ value: "cr", label: "Costa Rica" },
	{ value: "ci", label: "Elfenbeinküste" },
	{ value: "dk", label: "Dänemark" },
	{ value: "do", label: "Dominikanische Republik" },
	{ value: "dm", label: "Dominica" },
	{ value: "dj", label: "Dschibuti" },
	{ value: "ec", label: "Ecuador" },
	{ value: "sv", label: "El Salvador" },
	{ value: "er", label: "Eritrea" },
	{ value: "ee", label: "Estland" },
	{ value: "sz", label: "Eswatini" },
	{ value: "fj", label: "Fidschi" },
	{ value: "fi", label: "Finnland" },
	{ value: "ga", label: "Gabun" },
	{ value: "gm", label: "Gambia" },
	{ value: "ge", label: "Georgien" },
	{ value: "gh", label: "Ghana" },
	{ value: "gd", label: "Grenada" },
	{ value: "gr", label: "Griechenland" },
	{ value: "gt", label: "Guatemala" },
	{ value: "gn", label: "Guinea" },
	{ value: "gw", label: "Guinea-Bissau" },
	{ value: "gy", label: "Guyana" },
	{ value: "ht", label: "Haiti" },
	{ value: "hn", label: "Honduras" },
	{ value: "hk", label: "Hongkong" },
	{ value: "in", label: "Indien" },
	{ value: "id", label: "Indonesien" },
	{ value: "iq", label: "Irak" },
	{ value: "ir", label: "Iran" },
	{ value: "ie", label: "Irland" },
	{ value: "is", label: "Island" },
	{ value: "il", label: "Israel" },
	{ value: "jm", label: "Jamaika" },
	{ value: "jp", label: "Japan" },
	{ value: "ye", label: "Jemen" },
	{ value: "jo", label: "Jordanien" },
	{ value: "kh", label: "Kambodscha" },
	{ value: "cm", label: "Kamerun" },
	{ value: "ca", label: "Kanada" },
	{ value: "cv", label: "Kap Verde" },
	{ value: "kz", label: "Kasachstan" },
	{ value: "qa", label: "Katar" },
	{ value: "ke", label: "Kenia" },
	{ value: "kg", label: "Kirgisistan" },
	{ value: "ki", label: "Kiribati" },
	{ value: "co", label: "Kolumbien" },
	{ value: "km", label: "Komoren" },
	{ value: "cd", label: "Kongo, Demokratische Republik" },
	{ value: "cg", label: "Kongo, Republik" },
	{ value: "xk", label: "Kosovo" },
	{ value: "hr", label: "Kroatien" },
	{ value: "cu", label: "Kuba" },
	{ value: "kw", label: "Kuwait" },
	{ value: "la", label: "Laos" },
	{ value: "ls", label: "Lesotho" },
	{ value: "lv", label: "Lettland" },
	{ value: "lb", label: "Libanon" },
	{ value: "lr", label: "Liberia" },
	{ value: "ly", label: "Libyen" },
	{ value: "lt", label: "Litauen" },
	{ value: "lu", label: "Luxemburg" },
	{ value: "mo", label: "Macau" },
	{ value: "mg", label: "Madagaskar" },
	{ value: "mw", label: "Malawi" },
	{ value: "my", label: "Malaysia" },
	{ value: "mv", label: "Malediven" },
	{ value: "ml", label: "Mali" },
	{ value: "mt", label: "Malta" },
	{ value: "ma", label: "Marokko" },
	{ value: "mh", label: "Marshallinseln" },
	{ value: "mr", label: "Mauretanien" },
	{ value: "mu", label: "Mauritius" },
	{ value: "mx", label: "Mexiko" },
	{ value: "fm", label: "Mikronesien" },
	{ value: "md", label: "Moldau" },
	{ value: "mc", label: "Monaco" },
	{ value: "mn", label: "Mongolei" },
	{ value: "me", label: "Montenegro" },
	{ value: "mz", label: "Mosambik" },
	{ value: "mm", label: "Myanmar" },
	{ value: "na", label: "Namibia" },
	{ value: "nr", label: "Nauru" },
	{ value: "np", label: "Nepal" },
	{ value: "nz", label: "Neuseeland" },
	{ value: "ni", label: "Nicaragua" },
	{ value: "nl", label: "Niederlande" },
	{ value: "ne", label: "Niger" },
	{ value: "ng", label: "Nigeria" },
	{ value: "mk", label: "Nordmazedonien" },
	{ value: "kp", label: "Nordkorea" },
	{ value: "no", label: "Norwegen" },
	{ value: "om", label: "Oman" },
	{ value: "pk", label: "Pakistan" },
	{ value: "pw", label: "Palau" },
	{ value: "ps", label: "Palästina" },
	{ value: "pa", label: "Panama" },
	{ value: "pg", label: "Papua-Neuguinea" },
	{ value: "py", label: "Paraguay" },
	{ value: "pe", label: "Peru" },
	{ value: "ph", label: "Philippinen" },
	{ value: "pl", label: "Polen" },
	{ value: "pt", label: "Portugal" },
	{ value: "rw", label: "Ruanda" },
	{ value: "ro", label: "Rumänien" },
	{ value: "ru", label: "Russland" },
	{ value: "sb", label: "Salomonen" },
	{ value: "zm", label: "Sambia" },
	{ value: "ws", label: "Samoa" },
	{ value: "sm", label: "San Marino" },
	{ value: "st", label: "São Tomé und Príncipe" },
	{ value: "sa", label: "Saudi-Arabien" },
	{ value: "se", label: "Schweden" },
	{ value: "sn", label: "Senegal" },
	{ value: "rs", label: "Serbien" },
	{ value: "sc", label: "Seychellen" },
	{ value: "sl", label: "Sierra Leone" },
	{ value: "zw", label: "Simbabwe" },
	{ value: "sg", label: "Singapur" },
	{ value: "sk", label: "Slowakei" },
	{ value: "si", label: "Slowenien" },
	{ value: "so", label: "Somalia" },
	{ value: "es", label: "Spanien" },
	{ value: "lk", label: "Sri Lanka" },
	{ value: "kn", label: "St. Kitts und Nevis" },
	{ value: "lc", label: "St. Lucia" },
	{ value: "vc", label: "St. Vincent und die Grenadinen" },
	{ value: "za", label: "Südafrika" },
	{ value: "sd", label: "Sudan" },
	{ value: "kr", label: "Südkorea" },
	{ value: "ss", label: "Südsudan" },
	{ value: "sr", label: "Suriname" },
	{ value: "sy", label: "Syrien" },
	{ value: "tj", label: "Tadschikistan" },
	{ value: "tw", label: "Taiwan" },
	{ value: "tz", label: "Tansania" },
	{ value: "th", label: "Thailand" },
	{ value: "tl", label: "Timor-Leste" },
	{ value: "tg", label: "Togo" },
	{ value: "to", label: "Tonga" },
	{ value: "tt", label: "Trinidad und Tobago" },
	{ value: "td", label: "Tschad" },
	{ value: "cz", label: "Tschechien" },
	{ value: "tn", label: "Tunesien" },
	{ value: "tr", label: "Türkei" },
	{ value: "tm", label: "Turkmenistan" },
	{ value: "tv", label: "Tuvalu" },
	{ value: "ug", label: "Uganda" },
	{ value: "ua", label: "Ukraine" },
	{ value: "hu", label: "Ungarn" },
	{ value: "uy", label: "Uruguay" },
	{ value: "uz", label: "Usbekistan" },
	{ value: "vu", label: "Vanuatu" },
	{ value: "va", label: "Vatikanstadt" },
	{ value: "ve", label: "Venezuela" },
	{ value: "ae", label: "Vereinigte Arabische Emirate" },
	{ value: "vn", label: "Vietnam" },
	{ value: "cf", label: "Zentralafrikanische Republik" },
	{ value: "cy", label: "Zypern" },
];

export const countryLookup: Record<string, string> = Object.fromEntries(
	countryOptions.map(({ value, label }) => [value, label])
);
